export const getBaseUrl = (config, defaultBaseUrl) => config.withAbsoluteLinks ? config.absoluteBaseUrl ? config.absoluteBaseUrl : defaultBaseUrl : '';